/*
 *  This must be in its own module and imported at the very beginning of client/index.js.
 */

global.__IS_CLIENT__ = true;
global.__IS_SERVER__ = false;
